<template src="./template.html" />

<script>
/* eslint-disable */
import _ from 'lodash';
import { directive as onClickaway } from 'vue-clickaway';
import { mapGetters } from 'vuex';
import CountryFlag from 'vue-country-flag';
import InputText from '@/components/elements/inputs/text.vue';
import InputSelect from '@/components/elements/inputs/select.vue';
import CountrySelect from '@/components/elements/inputs/countrySelect.vue';
import StateSelect from '@/components/elements/inputs/stateSelect.vue';
import Toggle from '@/components/elements/inputs/toggle.vue';
import countryList from '@/data/country.js';
import { getGoogleMapsAPI } from 'gmap-vue';

export default {
  name: 'AddressPicker',
  components: {
    CountryFlag,
    InputSelect,
    InputText,
    Toggle,
    CountrySelect,
    StateSelect,
  },
  directives: {
    onClickaway: onClickaway,
  },
  props: {
    label: {
      type: String,
      default: 'address_1',
    },
    disableSearch: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'Type your address',
    },
    value: {
      type: Object,
      default: () => {
        return{
          address_1: '',
          address_2: '',
          country_id: '',
          post_code: '',
          city: '',
          state: '',
        }
      },
    }
  },
  data() {
    return {
      indexItem: 0,
      service: {},
      placeService: {},
      geocoder: {},
      inputSearch: '',
      isOpened: false,
      hasResults: false,
    };
  },
  computed: {
    ...mapGetters(['get_predictions_google', 'get_predictions_api']),
    postCode: {
      // getter
      get: function () {
        return (this.value.post_code || '').toUpperCase();
      },
      // setter
      set: function (newValue) {
        this.$emit('input', {
          address_1: this.value.address_1,
          address_2: this.value.address_2,
          country_id: this.value.country_id,
          post_code: (newValue || '').toUpperCase(),
          city: this.value.city,
          state: this.value.state,
        });
      }
    },
    google: getGoogleMapsAPI,
    getFlag() {
      if( this.value.country_id !== '' && this.value.country_id !== undefined){
        return countryList.filter((opt) => opt.id === this.value.country_id.toString())[0].alpha2;
      }
      return '';
    },
    haveState() {
      if( this.value.country_id !== '' && this.value.country_id !== undefined){
        return !!Number(countryList.filter((opt) => opt.id === this.value.country_id.toString())[0].has_state)
      }
      return false;
    },
    havePostcode() {
      if( this.value.country_id !== '' && this.value.country_id !== undefined){
        return !!Number(countryList.filter((opt) => opt.id === this.value.country_id.toString())[0].has_postcode)
      }
      return true;
    },
    randomSelectId() {
      return `select-${this.randomNumber()}`
    },
    groupedAddresses() {
      if (this.get_predictions_api.length === 0) return [];

      // Group by customer_id since customer_address records belong to a customer
      const grouped = _.groupBy(this.get_predictions_api, 'customer_id');

      return Object.keys(grouped).map(customerId => {
        const customerAddresses = grouped[customerId];
        const firstRecord = customerAddresses[0];

        // The address comes from the main customer record (stored in customer_address for this API)
        // All customer_address records for same customer_id share the same physical address
        const customerMainAddress = {
          address_1: firstRecord.address_1,
          address_2: firstRecord.address_2,
          post_code: firstRecord.post_code,
          city: firstRecord.city,
          country_id: firstRecord.country_id,
          state: firstRecord.state,
        };

        return {
          addressKey: `customer-${customerId}`,
          address: customerMainAddress,
          customer_id: customerId,
          contacts: customerAddresses.map(contactRecord => ({
            id: contactRecord.id, // customer_address.id
            customer_id: contactRecord.customer_id,
            name: contactRecord.name, // contact name from customer_address
            phone: contactRecord.phone, // contact phone from customer_address
            email: contactRecord.email, // contact email from customer_address
            company_name: contactRecord.company_name,
            vat: contactRecord.vat,
            external_customer_no: contactRecord.external_customer_no,

            // Add the additional shipping information fields
            has_additional_shipping_info: contactRecord.has_additional_shipping_info,
            goods_incoterm: contactRecord.goods_incoterm,
            duty_paid_by: contactRecord.duty_paid_by,
            duty_payer_account_no: contactRecord.duty_payer_account_no,
            freight_paid_by: contactRecord.freight_paid_by,
            freight_payer_account_no: contactRecord.freight_payer_account_no,
            freight_payer_id: contactRecord.freight_payer_id,
            invoice_type: contactRecord.invoice_type,
            eori: contactRecord.eori,
            eccn: contactRecord.eccn,
            customs_additional_info_text: contactRecord.customs_additional_info_text,
            eei_number: contactRecord.eei_number,
            tin_number: contactRecord.tin_number,
            tin_type: contactRecord.tin_type,
            selected_info_items: contactRecord.selected_info_items,
            selected_info_items_array: contactRecord.selected_info_items_array,
            additional_info_updated_at: contactRecord.additional_info_updated_at,

            displayName: contactRecord.name || `Contact #${contactRecord.id}`
          }))
        };
      });
    },
    margedResultList() {
      return {
        apiResults: this.get_predictions_api,
        googleResults: this.get_predictions_google,
      };
    },
  },
  mounted() {
    this.$refs.mapRefD.$mapPromise.then((map) => {
      this.service = new this.google.maps.places.AutocompleteService();
      this.placeService = new this.google.maps.places.PlacesService(this.$refs.bla);
      this.geocoder = new this.google.maps.Geocoder();
      if(this.value.address_1 !== ''){
        this.inputSearch = this.formatAddress(this.value);
      }
    })
  },
  methods: {
    // ADD THIS MISSING METHOD
    emitAdditionalShippingInfo(contact) {
      const additionalInfo = {
        goods_incoterm: contact.goods_incoterm,
        duty_paid_by: contact.duty_paid_by,
        duty_payer_account_no: contact.duty_payer_account_no,
        freight_paid_by: contact.freight_paid_by,
        freight_payer_account_no: contact.freight_payer_account_no,
        freight_payer_id: contact.freight_payer_id,
        invoice_type: contact.invoice_type,
        eori: contact.eori,
        eccn: contact.eccn,
        customs_additional_info_text: contact.customs_additional_info_text,
        eei_number: contact.eei_number,
        tin_number: contact.tin_number,
        tin_type: contact.tin_type,
        selected_info_items_array: contact.selected_info_items_array || []
      };

      // Remove null/undefined values
      Object.keys(additionalInfo).forEach(key => {
        if (additionalInfo[key] === null || additionalInfo[key] === undefined) {
          delete additionalInfo[key];
        }
      });

      // Only emit if there's actual additional info
      if (Object.keys(additionalInfo).length > 0) {
        this.$emit('additionalInfoSelected', {
          customer_id: contact.customer_id,
          additionalInfo: additionalInfo
        });
      }
    },
    highlight(itemToHighlight) {
      if (!itemToHighlight) return '';

      // Convert to string
      const text = String(itemToHighlight);

      // If no search term, return original
      if (!this.inputSearch || this.inputSearch.trim() === '') {
        return text;
      }

      // Create case-insensitive regex
      let reggie = new RegExp('(' + this.inputSearch.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'gi');
      let found = text.search(reggie) !== -1;

      if (!found) return text;

      // Wrap matches in styled span
      return text.replace(reggie, '<span class="highlight-text">$1</span>');
    },
    getFlagItem(country_id) {
      if( country_id !== '' && country_id !== undefined){
        return countryList.filter((opt) => opt.id === country_id.toString())[0].alpha2;
      }
      return '';
    },
    randomNumber() {
      return Math.floor(100000 + Math.random() * 900000);
    },
    nextItemApiList (event) {
      if(event.keyCode == 9) return;

      // Calculate total items for navigation (grouped addresses + google results)
      let totalApiItems = 0;
      this.groupedAddresses.forEach(group => {
        totalApiItems += group.contacts.length;
      });
      let totalItems = totalApiItems + this.margedResultList.googleResults.length;

      if (event.keyCode == 38 && this.indexItem > 0) {
        this.indexItem--;
        this.focusItem();
      } else if (event.keyCode == 40 && this.indexItem < totalItems - 1) {
        this.indexItem++;
        this.focusItem();
      } else if (event.keyCode == 13) {
        this.clickFocusedItem();
      }
    },
    nextItemGoogleList (event) {
      if(event.keyCode == 9) return;

      // Calculate total items for navigation
      let totalApiItems = 0;
      this.groupedAddresses.forEach(group => {
        totalApiItems += group.contacts.length;
      });
      let totalItems = totalApiItems + this.margedResultList.googleResults.length;

      if (event.keyCode == 38 && this.indexItem > 0) {
        this.indexItem--;
        this.focusItem();
      } else if (event.keyCode == 40 && this.indexItem < totalItems - 1) {
        this.indexItem++;
        this.focusItem();
      } else if (event.keyCode == 13) {
        this.clickFocusedItem();
      }
    },
    focusItem() {
      // Calculate total API items first
      let totalApiItems = 0;
      this.groupedAddresses.forEach(group => {
        totalApiItems += group.contacts.length;
      });

      if (this.indexItem < totalApiItems) {
        // Focus on API results (grouped)
        let currentIndex = 0;
        for (let groupIndex = 0; groupIndex < this.groupedAddresses.length; groupIndex++) {
          const group = this.groupedAddresses[groupIndex];
          for (let contactIndex = 0; contactIndex < group.contacts.length; contactIndex++) {
            if (currentIndex === this.indexItem) {
              const refName = `${groupIndex}-${contactIndex}-opt-address-picker`;
              if (this.$refs[refName] && this.$refs[refName][0]) {
                this.$refs[refName][0].focus();
              }
              return;
            }
            currentIndex++;
          }
        }
      } else {
        // Focus on Google results
        const googleIndex = this.indexItem - totalApiItems;
        const refName = `${this.indexItem}-opt-address-picker-google`;
        if (this.$refs[refName] && this.$refs[refName][0]) {
          this.$refs[refName][0].focus();
        }
      }
    },
    clickFocusedItem() {
      // Calculate total API items first
      let totalApiItems = 0;
      this.groupedAddresses.forEach(group => {
        totalApiItems += group.contacts.length;
      });

      if (this.indexItem < totalApiItems) {
        // Click on API results (grouped)
        let currentIndex = 0;
        for (let groupIndex = 0; groupIndex < this.groupedAddresses.length; groupIndex++) {
          const group = this.groupedAddresses[groupIndex];
          for (let contactIndex = 0; contactIndex < group.contacts.length; contactIndex++) {
            if (currentIndex === this.indexItem) {
              this.setAddressWithContact(group.address, group.contacts[contactIndex]);
              return;
            }
            currentIndex++;
          }
        }
      } else {
        // Click on Google results
        const googleIndex = this.indexItem - totalApiItems;
        if (this.margedResultList.googleResults[googleIndex]) {
          this.getPlaceDetail(this.margedResultList.googleResults[googleIndex].place_id);
        }
      }
    },
    formatAddressDropdown(address) {
      // Create a clean address string - main text only
      let addressParts = [];

      if (address.address_1) {
        addressParts.push(address.address_1);
      }

      if (address.post_code && address.city) {
        addressParts.push(`${address.post_code} ${address.city}`);
      } else if (address.city) {
        addressParts.push(address.city);
      } else if (address.post_code) {
        addressParts.push(address.post_code);
      }

      return addressParts.join(', ');
    },
    formatAddress(item) {
      let company = item.company_name ? `${item.company_name}, ` : '';
      let address_1 = item.address_1 ? `${item.address_1}, ` : '';
      let city = item.city ? `${item.city}, ` : '';
      let post_code = item.post_code ? `${item.post_code}, ` : '';
      let country_id = item.country_id ? `${countryList.filter(opt => opt.id == item.country_id)[0].name}` : '';
      let state = item.state ? `${item.state}, ` : '';
      return `${address_1}${post_code}${city}`.replace(/,\s*$/, "")
    },
    getContactDisplayName(contact) {
      // Show contact name, company, and ECN if available
      let parts = [];

      if (contact.name) {
        parts.push(contact.name);
      }

      if (contact.company_name) {
        parts.push(contact.company_name);
      }

      let displayName = parts.join(' - ');

      if (contact.external_customer_no) {
        displayName += `, ECN - ${contact.external_customer_no}`;
      }

      return displayName || `Contact #${contact.id}`;
    },
    cleanAddressData(addressData) {
      const cleaned = { ...addressData };
      if (!this.haveState) {
        cleaned.state = '';
      }

      return cleaned;
    },
    setAddress(item) {
      const cleanedItem = this.cleanAddressData(item);
      this.$emit('addressSelected', {...cleanedItem, typeOfAction: 'app'});
      this.hasResults = false;
      this.inputSearch = this.formatAddress(cleanedItem);
    },
    setAddressWithContact(address, contact) {
      this.inputSearch = this.formatAddress(address);

      const addressData = {
        ...address,
        name: contact.name,
        phone: contact.phone,
        email: contact.email,
        company_name: contact.company_name,
        vat: contact.vat,
        external_customer_no: contact.external_customer_no,
        customer_id: contact.customer_id,
        contact: contact,
        typeOfAction: 'app'
      };

      const cleanedAddressData = this.cleanAddressData(addressData);
      this.$emit('addressSelected', cleanedAddressData);

      if (contact.has_additional_shipping_info) {
        this.emitAdditionalShippingInfo(contact);
      }
      this.hasResults = false;
    },
    getPlaceDetail(id, latlng) {
      this.hasResults = false;
      const request = {
        placeId: id,
      };
      this.placeService.getDetails(request, (res) => {
        let addressObject = {
          address_1: '',
          post_code: '',
          city: '',
          state: '',
          country_id: '',
        };
        // console.log('GOOGLE SINGLE', res)
        for (const component of res.address_components) {
          const componentType = component.types[0];
          switch (componentType) { // spisergasse
            case "street_number": {
              addressObject.address_1 = `${component.long_name}`;
              break;
            }
            case "route": {
              addressObject.address_1 = `${component.long_name} ${addressObject.address_1}`;
              break;
            }
            case "postal_code": {
              addressObject.post_code = `${component.long_name}`;
              break;
            }
            case "postal_code_suffix": {
              // Only append suffix if base postal code exists; otherwise keep empty string
              if (addressObject.post_code) {
                addressObject.post_code = `${addressObject.post_code}-${component.long_name}`;
              }
              break;
            }
            case "locality": {
              addressObject.city = `${component.long_name}`
              break;
            }
            case "postal_town": {
              addressObject.city = `${component.long_name}`
              break;
            }
            case "country": {
              addressObject.country_id = countryList.filter(opt => opt.alpha2 == component.short_name)[0].id
              break;
            }
            case 'administrative_area_level_1': {
              addressObject.state = `${component.short_name}`
              break;
            }
          }
        }
        this.inputSearch = this.formatAddress(addressObject);
        this.$emit('addressSelected', {...addressObject, typeOfAction: 'google'});
      });
    },
    async makeCalls() {
      await this.$store.dispatch('GET_PLACE_API', {query : this.inputSearch, field : null});
      if (this.inputSearch.length >= 5) {
        // CREATE SESSION TOKEN FOR GOOGLE AUTOCOMPLETE
        let sessionToken = new google.maps.places.AutocompleteSessionToken();
        await this.service.getPlacePredictions({
          input: this.inputSearch,
          componentRestrictions: {country: this.value.country_id ? `${countryList.filter(opt => opt.id == this.value.country_id)[0].alpha2}` : ''},
          sessionToken,
          fields: ['address_components', 'geometry'],
          types: ['geocode'],
        }, (res) => {
          // console.log('GOOGLE', res)
          this.$store.dispatch('SET_PLACE_GOOGLE', res || []);
        });
      } else {
        this.$store.dispatch('SET_PLACE_GOOGLE', []);
      }
    },
    search: _.debounce(function(event) {
      if(event.keyCode == 9) return;
      if (event.keyCode == 38 || event.keyCode == 40) {
        if(this.groupedAddresses.length > 0 || this.margedResultList.googleResults.length > 0){
          this.focusItem();
        }
        return;
      }
      if(this.inputSearch != ''){
        this.makeCalls().then(() => {
          if(this.get_predictions_api.length != 0 || this.get_predictions_google.length != 0){
            this.hasResults = true;
          } else {
            this.isOpened = true;
            this.hasResults = false;
          }
        });
      } else {
        this.isOpened = false;
        this.hasResults = false;
      }
    }, 200),
    closeSelect() {
      // Delay closing slightly to avoid race conditions with click events
      // (e.g., clickaway triggering before the item click handler runs)
      setTimeout(() => {
        this.hasResults = false;
        this.isOpened = false;
      }, 120);
    },
    closeOnBlur(event) {
      if (event && typeof event.stopPropagation === 'function') {
        event.stopPropagation();
      }
      setTimeout(() => this.closeSelect(), 150);
    },
  },
  watch: {
    value: {
      handler(val){
        this.inputSearch = this.formatAddress(val);
      },
      deep: true
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/global/variables';

/* Modern Address Book Picker Styles */
.address-block {
  position: relative;
  width: 100%;
}

.search-result-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  z-index: 1000;
  max-height: 300px;
  overflow-y: auto;
  margin-top: 4px;
  padding: 12px;
}

.address-group {
  margin-bottom: 5px;
}

.address-group:last-child {
  margin-bottom: 0;
}

.address-header {
  display: flex;
  align-items: flex-start;
  gap: 18px;
  padding: 8px 0 0 15px;
  margin-bottom: 5px;
}

.address-flag {
  flex-shrink: 0;
  margin-top: 0;
  padding: 2px;
  position: relative;
  left: -2px;
  top: -3px;
}

.address-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.address-text {
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
  line-height: 1.3;
}

.contacts-wrapper {
  margin-left: 46px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  position: relative;
}

.contacts-wrapper::before {
  content: '';
  position: absolute;
  left: -30px;
  top: -10px;
  bottom: 13px;
  width: 1px;
  background: #d1d5db;
}

.contact-item {
  padding: 4px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.15s ease;
  background: transparent;
  position: relative;
}

.contact-item::before {
  content: '';
  position: absolute;
  left: -30px;
  top: 50%;
  width: 14px;
  height: 1px;
  background: #d1d5db;
  transform: translateY(-50%);
}

.contact-item:hover {
  background: #f9fafb;
}

.contact-item:focus {
  outline: none;
  background: #eff6ff;
}

.contact-name {
  font-size: 14px;
  line-height: 1.4;
  cursor: pointer;
  text-decoration: none;
  display: block;
}

.contact-name:hover {
  text-decoration: underline;
}

/* Separator styles */
.separator {
  height: 1px;
  background: #e5e7eb;
  margin: 8px 0;
}

.separator.small {
  margin: 4px 0;
}

/* Keep original Google section styles */
ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.list-title {
  padding: 8px 12px;
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  display: flex;
  align-items: center;
  gap: 8px;
}

.list-item {
  padding: 12px;
  cursor: pointer;
  border-bottom: 1px solid #f3f4f6;
  transition: background-color 0.15s ease;
  position: relative;
}

.list-item:hover {
  background: #f9fafb;
}

.list-item:focus {
  outline: none;
  background: #eff6ff;
}

.list-item:last-child {
  border-bottom: none;
}

/* Highlight styles for search matches */
::v-deep .highlight-text {
  background-color: rgba(251, 191, 36, 0.15);
  font-weight: 600;
  padding: 0;
  border-radius: 0;
  color: inherit;
}

/* Legacy highlight for backwards compatibility */
.address-text b,
.contact-name b {
  background-color: #fef3c7;
  font-weight: 700;
  padding: 1px 2px;
  border-radius: 2px;
}

/* Scrollbar styling */
.search-result-dropdown::-webkit-scrollbar {
  width: 6px;
}

.search-result-dropdown::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 3px;
}

.search-result-dropdown::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

.search-result-dropdown::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* Animation for dropdown appearance */
.search-result-dropdown {
  animation: dropdownFadeIn 0.15s ease-out;
}

@keyframes dropdownFadeIn {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive design */
@media (max-width: 640px) {
  .search-result-dropdown {
    max-height: 300px;
  }

  .address-text {
    font-size: 13px;
  }

  .contact-name {
    font-size: 12px;
  }

  .contacts-wrapper {
    margin-left: 42px;
  }

  .contacts-wrapper::before {
    left: -26px;
  }

  .contact-item::before {
    left: -26px;
  }

  .address-header {
    padding: 6px 0 0 6px;
    gap: 10px;
  }
}
</style>
